export default function toIDR(value) {
  if ((!value && value !== 0) || isNaN(Number(value))) return 0;
  return value.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });
}
